import * as React from 'react'

interface UseImagePreviewReturn {
  isOpen: boolean
  currentImage: { src: string; alt: string } | null
  openPreview: (src: string, alt?: string) => void
  closePreview: () => void
}

export function useImagePreview(): UseImagePreviewReturn {
  const [isOpen, setIsOpen] = React.useState(false)
  const [currentImage, setCurrentImage] = React.useState<{ src: string; alt: string } | null>(null)

  const openPreview = (src: string, alt = '') => {
    setCurrentImage({ src, alt })
    setIsOpen(true)
  }

  const closePreview = () => {
    setIsOpen(false)
    setTimeout(() => setCurrentImage(null), 200)
  }

  return {
    isOpen,
    currentImage,
    openPreview,
    closePreview,
  }
}
